export default __webpack_public_path__ + "static/media/delete-bin.944b54f9.svg";